<template>
    <div class="commonTableStyles_w selectSupply">
        <HeaderNav
            header-title="选择供应单"
            left-icon-name="2"
            right-icon-name=""
        ></HeaderNav>
        <div class="warpper" :style="{height: contentHeight}" :class="{ 'no_data': isActive }">
            <van-search v-model="searchKey" placeholder="请输入搜索信息" @change="search"></van-search>
            <van-pull-refresh>
                <van-list
                    v-model="loading"
                    :finished="finished"
                    :immediate-check="false"
                    :finished-text="finishedText"
                    :error.sync="error"
                    :error-text="errorText"
                    @load="onLoad"
                >
                    <div
                        class="materialPlan-item"
                        v-for="(item) in list"
                        :key="item.poid"
                        :immediate-check="false"
                    >
                        <ul>
                            <li class="tit">
                                <span class="corner-marker order-yqr" v-if="item.supplier_state===6">已确认</span>
                                <span class="corner-marker order-wqr" v-else>未确认</span>
                                <span class="info">供应单编号：{{ item.no }}</span>
                            </li>
                            <li class="name-length">
                                <span class="pre-icon materialPlan01"></span>
                                <span class="info">供应商名称：{{ item.supplier_name }}</span>
                            </li>
                            <li class="name-length">
                                <span class="pre-icon materialPlan01"></span>
                                <span class="info">运输单位：{{ item.transport_name }}</span>
                            </li>
                            <li>
                                <van-row>
                                    <van-col span="12">
                                        <span class="pre-icon materialPlan01"></span>
                                        <span class="info">物料名称：{{ item.goods_name }}</span>
                                    </van-col>
                                    <van-col span="12">
                                        <span class="pre-icon materialPlan03"></span>
                                        <span class="info">规格：{{ item.spec_name }}</span>
                                    </van-col>
                                </van-row>
                            </li>
                            <li>
                                <van-row>
                                    <van-col span="12">
                                        <span class="pre-icon materialPlan05"></span>
                                        <span class="info info-bar">计划量：{{ item.supply_count }}吨</span>
                                    </van-col>
                                    <van-col span="12">
                                        <span class="pre-icon materialPlan05"></span>
                                        <span class="info info-bar">过磅净重合计：{{ item.actual_total_net_weight }}吨</span>
                                    </van-col>
                                </van-row>
                            </li>
                            <li class="name-length">
                                <span class="pre-icon materialPlan04"></span>
                                <span class="info">供应场站：{{ item.station_name }}</span>
                            </li>
                            <li>
                                <span class="pre-icon materialPlan06"></span>
                                <span class="info">供应时间：{{ item.supply_date }}</span>
                            </li>
                            <li class="name-length" v-show="item.supplier_state === 6">
                                <span class="pre-icon materialPlan08"></span>
                                <span class="info">备注：{{ item.confirm_remarks || '暂无备注信息' }}</span>
                            </li>
                        </ul>
                        <div class="btn-wrapper" v-if="item.supplier_state !== 6">
                            <van-row type="flex" justify="space-around">
                                <van-col span="24">
                                    <van-button
                                        type="info"
                                        class="btn btn_order_taking"
                                        @click="configSelect(item)"
                                    >
                                        确认
                                    </van-button>
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
        <!-- <span class="return-btn" @click="handleBack"><i class="iconfont ">&#xe607;</i></span> -->
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { eventBus } from '@/common/eventBus.ts';
export default {
    name: 'select-supply',
    components: {
        HeaderNav,
    },
    data() {
        return {
            // 接单list
            list: [],
            loading: true,
            finished: false,
            searchKey: '',
            page: {
                pageindex: 1,
                pagesize: 20,
            },
            contentHeight: '',
            isActive: false,
            error: false,
            errorText: '',
            finishedText: '没有更多了',
            balance_number: '',
        };
    },
    mounted() {
        this.balance_number = this.$route.query.balance_number;
        // 初始化接单列表数据
        this.getList();
        this.contentHeight = document.documentElement.clientHeight - 44.8 + 'rpx';
    },
    methods: {
        handleBack() {
            this.$router.isBack = 1;
            this.$router.back();
        },
        // 搜索
        search() {
            this.page.pageindex = 1;
            this.finished = false;
            this.list = [];
            this.getList();
        },
        // 滚动条滑到底部触发的事件
        onLoad() {
            setTimeout(() => {
                this.page.pageindex += 1;
                this.getList();
            }, 200);
        },
        // 获取接单列表
        getList() {
            this.$axios
                .get('/interfaceApi/procurement/daily/supply/get_choose_supply_list?'
                        + 'pageindex=' + this.page.pageindex + '&pagesize=' + this.page.pagesize + '&searchKey=' + this.searchKey)

                .then(res => {
                    this.loading = false;
                    this.list.push(...res.rows);
                    if (this.list.length >= res.total) {
                        this.finished = true;
                    }
                    if (this.list.length === 0 ) {
                        this.finishedText = '';
                        this.isActive = true;
                        this.finished = true;
                    } else {
                        this.isActive = false;
                    }
                })
                .catch(error => {
                    this.error = true;
                    this.loading = false;
                    this.errorText = error.ErrorCode.Message;
                });
        },
        configSelect(item) {

            this.$axios.get('/interfaceApi/procurement/balance/relation/supply/beforecheck/' + this.balance_number + '/' + item.no + '/1')
                .then(res => {
                    if (res) {
                        this.$toast.success('操作成功。');
                        eventBus.$emit('updateInspectionOneData');
                        this.$router.isBack = 1;
                        this.$router.back();
                    }
                }).catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
    },
};
</script>

<style lang="stylus" scoped>
    .van-pull-refresh
        height calc(100% - 45rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
    .selectSupply
        padding-top 44rpx
        height calc(100% - 44rpx)
        .return-btn
            position absolute
            top 11rpx
            left 15rpx
            color #fff
            font-size 10rpx
            z-index 999
        .warpper
            height 100%
            width 100%
            background #F0F0F0
            overflow-y auto
            padding 0 12rpx 0 12rpx
            &.no_data
                background url(../../../assets/images/common/no_data.png) left center no-repeat
                background-size contain
            .materialPlan-item
                width 100%
                background #ffffff
                margin-top 15rpx
                position relative
                overflow hidden
                color #666666
                font-size 14rpx
                li
                    overflow hidden
                    margin-bottom 10rpx
                    &.name-length
                        display flex
                        .info
                            flex 1
                    .pre-icon
                        width 16rpx
                        height 16rpx
                        float left
                        background-size 100% 100%
                        background-repeat no-repeat
                        display inline-block
                        margin 2rpx 10rpx 0 0
                        &.materialPlan01
                            background-image url(../../../assets/images/icons/icon_gy_3.png)
                        &.materialPlan02
                            background-image url(../../../assets/images/icons/icon_34.png)
                        &.materialPlan03
                            background-image url(../../../assets/images/icons/icon_gy_5.png)
                        &.materialPlan04
                            background-image url(../../../assets/images/icons/icon_gy_2.png)
                        &.materialPlan05
                            background-image url(../../../assets/images/icons/icon_30.png)
                        &.materialPlan06
                            background-image url(../../../assets/images/icons/icon_gy_7.png)
                        &.materialPlan07
                            background-image url(../../../assets/images/icons/icon_gy_1.png)
                        &.materialPlan08
                            background-image url(../../../assets/images/icons/icon_gy_4.png)
                    .info
                        float left
                        font-size 14rpx
                    .info-bar
                        float left
                        width 125rpx
                        white-space nowrap
                        text-overflow ellipsis
                        overflow hidden
                    &.tit
                        color #061F3E
                .order-yqr
                    background #979EA7
                .order-wqr
                    background #FF6600
                .btn-wrapper
                    border-top 2rpx dashed #e4e2e2
                    padding 10rpx
                    position relative
                    .before-round
                        position absolute
                        width 20rpx
                        height 20rpx
                        border-radius 10rpx
                        background #F0F0F0
                        left -26rpx
                        top -10rpx
                    .after-round
                        position absolute
                        width 20rpx
                        height 20rpx
                        border-radius 10rpx
                        background #F0F0F0
                        right -26rpx
                        top -10rpx
                    .btn-text
                        text-align center
                        color #5494F3
                        font-size 14rpx
                    .input-wrapper
                        width 100%
                        height 47rpx
                        border 1px solid rgba(215,215,215,1)
                        background rgba(251,251,251,1)
                        margin-bottom 15rpx
                        display flex

                        p
                            width 45rpx
                            height 45rpx
                            line-height 45rpx
                            text-align center
                        input
                            flex 1
                            height 30rpx
                            margin-top 7.5rpx
                            border none
                            background none
                            line-height 24rpx
                            margin-right 15rpx
                            font-size 14rpx
                    .btn
                        width 100%
                        height 30rpx
                        line-height 30rpx
                        border-radius 4rpx
                        cursor pointer
                    .vertical-bar
                        width 2rpx
                        height 15rpx
                        background rgba(215,215,215,1)
                        position absolute
                        top 50%
                        left 50%
                        margin-top 32rpx
                        margin-left -2rpx
</style>
<style>
    .materialPlan-box .van-list__error-text, .van-list__finished-text, .van-list__loading{
        position: relative;
        height: 50rpx;
    }
    .materialPlan-box .van-loading__spinner{
        position: relative!important;
        top: 0!important;
        left: 0!important;
        display: inline-block;
        width: 30px;
        max-width: 100%;
        height: 30px;
    }

</style>
